import "./App.css";
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box, Container } from "@mui/material";
import theme from "./theme";
import NavBar from "./components/NavBar";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";
import HeaderContainer from "./container/HeaderContainer";
import AboutContainer from "./container/AboutContainer";
import ContactContainer from "./container/ContactContainer";
import ProjectsContainer from "./container/ProjectsContainer";
import SkillsContainer from "./container/SkillsContainer";
import WorkTimelineContainer from "./container/WorkTimelineContainer";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          background:
            "linear-gradient(160deg, #09090b 0%, #0c0a14 50%, #09090b 100%)",
        }}
      >
        <NavBar />
        <HeaderContainer />
        <Container maxWidth="lg">
          <AboutContainer />
          <SkillsContainer />
          <ProjectsContainer />
          <WorkTimelineContainer />
          <ContactContainer />
        </Container>
        <Footer />
        <ScrollToTop />
      </Box>
    </ThemeProvider>
  );
}

export default App;
